import { useState, useCallback } from "react";

const useToggle = (initial: boolean = false) => {
    const [toggle, setToggle] = useState<boolean>(initial)

    const handleToggle = useCallback(() => {
        setToggle(!toggle)
    },[toggle])

    const manualToggle = useCallback((value: boolean) => {
        setToggle(value)
    },[])

    return[
        toggle,
        handleToggle,
        manualToggle,
     ] as const
}

export default useToggle;